// Click a link with class "photo-lightbox" and the target image opens in a
// full-screen overlay.  Click anywhere on the overlay, press Escape, or
// swipe on mobile to close.  Zero markup required beyond the class name.

let overlay = null;

function open_lightbox(src) {
  close_lightbox();
  overlay = document.createElement('div');
  overlay.className = 'photo-lightbox-overlay';
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'background:rgba(0,0,0,0.9)',
    'z-index:2000',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'cursor:zoom-out',
    'padding:1rem',
  ].join(';');

  const img = document.createElement('img');
  img.src = src;
  img.alt = '';
  img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;box-shadow:0 4px 24px rgba(0,0,0,0.5);';

  overlay.appendChild(img);
  overlay.addEventListener('click', close_lightbox);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';
  document.addEventListener('keydown', on_key);
}

function close_lightbox() {
  if (!overlay) return;
  overlay.remove();
  overlay = null;
  document.body.style.overflow = '';
  document.removeEventListener('keydown', on_key);
}

function on_key(e) {
  if (e.key === 'Escape') close_lightbox();
}

function on_click(e) {
  const link = e.target.closest('a.photo-lightbox');
  if (!link) return;
  e.preventDefault();
  open_lightbox(link.href);
}

document.addEventListener('click', on_click);
document.addEventListener('turbolinks:before-cache', close_lightbox);
